var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col auto dropDownAnalisis" },
    [
      _c(
        "multiselect",
        {
          attrs: {
            "deselect-label": "",
            "select-label": "",
            "open-direction": "bottom",
            "track-by": "id",
            label: "title",
            options: _vm.acResult,
            multiple: false,
            placeholder: "Busque por analista",
            "show-no-results": false,
          },
          on: { "search-change": _vm.searchJournalist, select: _vm.selectOpt },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (props) {
                return [
                  _c("img", {
                    attrs: {
                      src: props.option.newImage,
                      alt: props.option.rawTitle,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(props.option.title) },
                  }),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "noOptions" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s("Digite el nombre del analista") },
            }),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }